import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { AppStore } from "../types";
import { createDashboardSlice } from "./dashboardSlice";
import { createInventorySlice } from "./inventorySlices";
import { createInvoiceSlice } from "./invoiceSlice";
import { createAuditSlice } from "./auditsMaintenanceSlice";
import { createAuthSlice } from "./authSlice";
import { format, startOfMonth } from "date-fns";

const DEV_MODE = import.meta.env.VITE_APP_ENV === "development";

const today = new Date()
const startOfThisMonth = startOfMonth(today);
const endOfThisMonth = today.getDate() === 1 ? startOfThisMonth : today;

export const initialState = {
  auth: {
    profile: null
  },
  dashboard: {
    leads: {
      filters: {
        dateRange: {
          start: format(startOfThisMonth, "yyyy-MM-dd"),
          end: format(endOfThisMonth, "yyyy-MM-dd"),
        },
        quickFilter: "thisMonth",
      },
      isFiltering: false,
      modalFilter: {
        status: ""
      }
    },
    fleet: {
      modals: {
        scoreOperation: false,
      },
    },
    maintenances: {
      modals: {
        filters: false
      }, 
      filters: {
        dateFilters: {
          startDate: format(startOfThisMonth, "yyyy-MM-dd"), 
          endDate: format(endOfThisMonth, "yyyy-MM-dd")
        }
      }
    }
  },
  inventories: {
    filters: {
      situation: null,
      city: null,
    },
    modals: {
      isImageCaptureOpen: false,
      isChangeStatusVehiclesOpen: false,
    },
    isConvertingImagesToText: false,
    licensePlates: [],
    sucessProcessImages: false,
  },
  invoice: {
    page: 1,
    filters: {
      status: "",
      search: "",
    },
    modals: {
      isOpen: false,
      cancellationIsOpen: false,
    },
  },
  audits: {
    vehicleMaintenance: {
      filters: {
        page: 1,
        search: "",
        status: [],
        itemsPerPage: 10,
      },
    },
  },
};

export const useAppStore = create<AppStore>()(
  devtools(
    immer((...args) => ({
      ...createDashboardSlice(...args),
      ...createInventorySlice(...args),
      ...createInvoiceSlice(...args),
      ...createAuditSlice(...args),
      ...createAuthSlice(...args)
    })),
  ),
);

if (DEV_MODE) {
  useAppStore.subscribe((state, prevState) => {
    console.log("Zustand state change:", {
      previous: prevState,
      current: state,
    });
  });
}
